const isObject = (obj): boolean => obj && obj.toString() === '[object Object]';

export const shallowEqual = (obj1, obj2): boolean => {
  if (!isObject(obj1) || !isObject(obj2)) {
    return false;
  }
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  for (var key in obj1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};
